module.exports = __webpack_public_path__ + "img/web-22.ba904999.png";